import { createFeature } from '@ngrx/store';
import { headerRemindersReducer } from './header-reminders-reducer';

export const headerRemindersFeature = createFeature({
  name: 'headerReminders',
  reducer: headerRemindersReducer
});
